import React, { Fragment } from 'react';
import NumberFormat from 'react-number-format';
import { bool, number } from 'prop-types';

const FormatPercentage = ({ value, isSymbol, useBracket, decimalScale }) => (
  <NumberFormat
    value={value}
    displayType="text"
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={decimalScale}
    suffix="%"
    renderText={(parseValue) => {
      let revaluated = 0;
      if (isSymbol) {
        if (parseFloat(value) === 0) {
          if (useBracket) {
            revaluated = `(${parseValue})`;
          } else {
            revaluated = parseValue;
          }
        } else if (parseFloat(value) > 0) {
          if (useBracket) {
            revaluated = `+(${parseValue})`;
          } else {
            revaluated = `+${parseValue}`;
          }
        } else if (useBracket) {
          revaluated = `-(${parseValue.substr(1)})`;
        } else {
          revaluated = `${parseValue}`;
        }
      } else {
        revaluated = parseValue;
      }
      return <Fragment>{revaluated}</Fragment>;
    }}
  />
);

FormatPercentage.propTypes = {
  decimalScale: number,
  isSymbol: bool,
  useBracket: bool,
  value: number
};
FormatPercentage.defaultProps = {
  decimalScale: 2,
  isSymbol: false,
  useBracket: false,
  value: 0
};

export default FormatPercentage;
